<template>
    <div class="slider">
        <div
            class="slider__inner"
            :class="{ '--center': name === 'carousel' && data.length === 1 }"
            :style="carouselStyle()"
            @transitionend="changeCarouselPosition()"
            @mousedown="slideStartPc($event)"
            @touchstart="slideStartSp($event)">
            <!-- 無限ループ用ダミー -->
            <template v-if="data.length > 1">
                <slider-img
                    :img-info="data[data.length - 2]"
                    :img-length="data.length"
                    :name="name"
                    :img-path="data[data.length - 2].imgPath"
                    :img-width="imgWidth"
                    :img-height="imgHeight">
                </slider-img>
                <slider-img
                    :img-info="data[data.length - 1]"
                    :img-length="data.length"
                    :name="name"
                    :img-path="data[data.length - 1].imgPath"
                    :img-width="imgWidth"
                    :img-height="imgHeight">
                </slider-img>
            </template>
            <div
                v-for="(item, index) in data"
                :key="'image' + index"
                class="slider__item">
                <slider-img
                    :imgInfo="item"
                    :imgLength="data.length"
                    :name="name"
                    :img-path="item.imgPath"
                    :img-width="imgWidth"
                    :img-height="imgHeight"
                    @onMouseup="slideEndPc"
                    @onDragend="slideEndPc"
                    @onTouchend="slideEndSp">
                </slider-img>
            </div>
            <!-- 無限ループ用ダミー -->
            <template v-if="data.length > 1">
                <slider-img
                    :img-info="data[0]"
                    :img-length="data.length"
                    :name="name"
                    :img-path="data[0].imgPath"
                    :img-width="imgWidth"
                    :img-height="imgHeight">
                </slider-img>
                <slider-img
                    :img-info="data[1]"
                    :img-length="data.length"
                    :name="name"
                    :img-path="data[1].imgPath"
                    :img-width="imgWidth"
                    :img-height="imgHeight">
                </slider-img>
            </template>
        </div>
        <ul v-if="name === 'mainVisual'" class="slider__indicator">
            <li
                v-for="n in data.length"
                :key="'indicator' + n"
                class="slider__dot"
                :class="{ '--active': n - 1 === active || (active < 0 && n - 1 === data.length - 1) || (active > data.length - 1 && n - 1 === 0) }">
            </li>
        </ul>
    </div>
</template>

<script>
import { isIOS, isAndroid } from "../assets/js/util"
import SliderImg from './SliderImg'

export default {
    name: "Slider",
    props: ['data', 'name', 'intervalTime', 'imgWidth', 'imgHeight'],
    components: { SliderImg },
    data() {
        return {
            timer: null,     // setIntervalの処理を入れておく
            disableButtonFlag: false, // 連打防止
            active: 0,       // 表示中の画像
            pos: null,       // フリック処理の開始位置(X座標)
            scrollY: null,   // バナー画像上でのスクロールの開始位置(Y座標)
            animationFlag: false, // カルーセルバナーを切り替えるアニメーションのフラグ
        }
    },
    computed: {
    },
    created: function () {
        this.active = 0;
        this.animationFlag = true;
    },
    mounted: function () {
        this.settimer()
    },
    methods: {
        settimer() {
            this.timer = setTimeout(() => {
                if(this.data.length > 1) this.next();
            }, this.intervalTime);
        },
        /**
         * カルーセルを戻す(左へ)
         */
        back() {
            if (this.disableButtonFlag) return;
            this.disableButtonFlag = true;
            this.animationFlag = true;
            clearTimeout(this.timer);
            this.active--;
            this.timer = setTimeout(() => {
                this.next();
            }, this.intervalTime);
            this.disableButtonFlag = false;
        },
        /**
         * カルーセルを進める(右へ)
         */
        next() {
            if (this.disableButtonFlag) return;
            this.disableButtonFlag = true;
            this.animationFlag = true;
            clearTimeout(this.timer);
            this.active++;
            this.timer = setTimeout(() => {
                this.next();
            }, this.intervalTime);
            this.disableButtonFlag = false;
        },
        /**
         * PCでの切り替わり処理
         * @param {*} event
         * @param { Object } item クリックしたバナー情報
         */
        slideStartPc(event) {
            // クリックした開始位置取得
            this.pos = event.pageX;
        },
        slideEndPc(event, item) {
            // PC用の処理なのでモバイルでは実行させない
            if(isIOS() || isAndroid()) return;

            const moveNum = this.pos - event.pageX;
            // 次の画像表示
            if (moveNum >= 70) {
                this.next();
                return;
            }
            // 前の画像表示
            if (moveNum <= -70){
                this.back()
                return;
            }
            // クリックとみなして遷移処理
            if (moveNum >= -10 && moveNum <= 10) this.onBunnerUrl(item);
        },
        /**
         * フリック時の切り替わり処理
         * @param {*} event
         * @param { Object } item タッチしたバナー情報
         */
        slideStartSp(event) {
            this.pos = event.changedTouches[0].pageX;
            this.scrollY = window.scrollY;
        },
        slideEndSp(event, item) {
            // iOSの慣性スクロールが敏感なので指を離したらスクロール停止
            const newScrollY = window.scrollY;
            window.scrollTo(0, newScrollY);

            // タッチが終了したX座標の差分を移動距離として算出
            const moveNum = this.pos - event.changedTouches[0].pageX;
            // 次の画像表示
            if (moveNum >= 70) {
                this.next();
                return;
            }
            // 前の画像表示
            if (moveNum <= -70){
                this.back()
                return;
            }

            const diffScrollY = this.scrollY - window.scrollY;
            // クリックとみなして遷移処理
            if (moveNum >= -10 && moveNum <= 10 && diffScrollY >= -10 && diffScrollY <= 10 ) this.onBunnerUrl(item);
        },
        getImg(img) {
            return process.env.VUE_APP_STATIC_CONTENT_SERVER_URL + img
        },
        /**
         * カルーセルバナー時はバナーの位置調整
         */
        carouselStyle(){
            if(this.data.length <= 1) return '';

            // コピーした要素2個分右に移動させないといけないので+2
            const currentIndex = this.active + 2;
            if(this.name === 'carousel') {
                return {
                    transition: this.animationFlag ? 'transform .5s ease 0s' : 'none',
                    // バナー画像一枚分と前後のバナーの両端+余白分移動
                    transform: 'translate3d(' + (-currentIndex * 327 + 30) + 'px, 0, 0)',
                }
            }
            if(this.name === 'mainVisual') {
                return {
                    transition: this.animationFlag ? 'transform .5s ease 0s' : 'none',
                    // バナー画像一枚分移動
                    transform: 'translate3d(' + (-currentIndex * 375) + 'px, 0, 0)',
                }
            }
        },
        // 画面に表示するバナー位置の制御
        changeCarouselPosition(){
            this.animationFlag = false;
            this.active = (this.active + this.data.length) % this.data.length;
        },
        /**
         * URLが設定されていれば遷移
         * @param { Object } item
         */
        onBunnerUrl(item){
            /**
             * item.annouceType(数値によって処理や遷移先を分ける)
             * 2: お知らせ詳細画面へ遷移
             * 6: 有料会員登録画面へ遷移
             * 7: アンケートページを開く
             * 8: 外部URLを開く
             * 10: pit連携用のダイアログを開く
             */
            switch (item.announceType) {
                case 2:
                    this.$router.push({ name: 'newsDetail', params: { id: item.optionId01 } });
                    break;
                case 6:
                    this.$router.push('/MemberBenefits')
                    break;
                case 7:
                    sessionStorage.setItem('questionaryUrl', item.url)
                    this.$router.push("/Questionary");
                    break;
                case 8:
                    window.open(item.url)
                    break;
                case 10:
                    this.$emit('pit')
                    break;
                default:
                    break;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.slider {
    // iOSで横向きにするとslider-imgが親要素をはみ出る問題の解決
    width: 375px;
    overflow: hidden;

    &__inner {
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: center;
        transform-style: preserve-3d; // AndroidのChromeで起きるバナーのちらつき対策

        &.--center {
            justify-content: center;
        }
    }

    &__item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: fit-content;
    }

    &__img {
        background-repeat: no-repeat;
        background-size: 100%;
        &.--marginRight { margin-right: 15px; }
    }

    &__indicator {
        height: 12px;
        display: flex;
        justify-content: center;
        margin-bottom: 18px;
    }

    &__dot {
        width: 6px;
        height: 6px;
        margin: 3px;
        border-radius: 50%;
        background-color: #cfcbcb;
        list-style: none;

        &.--active {
            background-color: #f6627a;
        }
    }
}
</style>